import React from "react";
import { Controller } from "react-hook-form";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";
import { Typography, Box } from "@mui/material";

const RHFQuillEditor = ({
  name,
  control,
  label,
  required,
  defaultValue = "",
  ...props
}) => {
  return (
    <Box sx={{ mb: 2 }}>
      {label && (
        <Typography variant="subtitle2" gutterBottom>
          {label} {required && <span style={{ color: "red" }}>*</span>}
        </Typography>
      )}
      <Controller
        name={name}
        control={control}
        defaultValue={defaultValue}
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <>
            <ReactQuill
              value={value || ""}
              onChange={onChange}
              {...props}
              style={{ height: "250px", marginBottom: "50px" }}
              theme="snow"
            />
            {error && (
              <Typography color="error" variant="caption">
                {error.message}
              </Typography>
            )}
          </>
        )}
      />
    </Box>
  );
};

export default RHFQuillEditor;
